import { RegistrySettings } from 'types/common';

export const getRegistryTitle = ({ settings }: RegistrySettings) => settings?.general?.title;
export const getRegistryTitleFull = ({ settings }: RegistrySettings) => settings?.general?.titleFull;
